import * as React from 'react';
import { useIntl } from 'react-intl';

import {
  InfoCircleIcon,
  TooltipModel,
  ReactFCC,
} from '@notino/react-styleguide';

import { PortalTooltip } from '@components/PortalTooltip';
import globalMessages from '@messages';

import { watchdogMessages } from '../../watchdogMessages';

import { WatchdogInputWrapper, IconWrapper, TooltipContent } from './styled';

export const WatchdogEmailInputWrapper: ReactFCC = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <WatchdogInputWrapper>
      {children}
      <IconWrapper>
        <PortalTooltip
          position={TooltipModel.Position.topLeft}
          interactive={true}
          content={
            <PortalTooltip.Content shouldWrapText={false}>
              <TooltipContent>
                {formatMessage(watchdogMessages.watchdogGDPRinfo, {
                  link: (
                    <a
                      key="globalGdprLink"
                      href={formatMessage(globalMessages.globalGDPRLink)}
                      // eslint-disable-next-line react/jsx-no-target-blank
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formatMessage(globalMessages.globalGDPRLinkText)}
                    </a>
                  ),
                })}
              </TooltipContent>
            </PortalTooltip.Content>
          }
        >
          <InfoCircleIcon color="icon.tertiary" width="20px" height="20px" />
        </PortalTooltip>
      </IconWrapper>
    </WatchdogInputWrapper>
  );
};
